import { render, staticRenderFns } from "./PendingApproval.vue?vue&type=template&id=772376f5&scoped=true"
import script from "./PendingApproval.vue?vue&type=script&lang=js"
export * from "./PendingApproval.vue?vue&type=script&lang=js"
import style0 from "./PendingApproval.vue?vue&type=style&index=0&id=772376f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772376f5",
  null
  
)

export default component.exports